<div class="app-process-list__wrapper">
  @if (!isDraftProcess()) {
    <div
      class="app-process-list__status-bar"
      [class.app-process-list__status-bar--in-progress]="
        fundRaiseProcess.raiseFundApplicationProcessStatusType !==
        RaiseFundApplicationProcessStatusType.Approved
      "
      [class.app-process-list__status-bar--success]="
        fundRaiseProcess.raiseFundApplicationProcessStatusType ===
        RaiseFundApplicationProcessStatusType.Approved
      "
    >
      <div class="app-process-list__status-bar-wrapper">
        <span class="tw-uppercase tw-text-black">Status</span>

        <span class="app-process-list__status-bar-text">
          <i class="fa fa-circle app-process-list__status-bar-icon"></i>
          @switch (fundRaiseProcess.raiseFundApplicationProcessStatusType) {
            @case (RaiseFundApplicationProcessStatusType.Approved) {
              {{ 'raise.Approved' | translate }}
            }
            @default {
              {{ 'raise.InProgress' | translate }}
            }
          }
        </span>
      </div>

      @if (
        fundRaiseProcess.raiseFundApplicationProcessStatusType ===
        RaiseFundApplicationProcessStatusType.Approved
      ) {
        <div class="tw-mt-1 tw-text-xs tw-font-normal tw-text-body">
          {{
            'raise.lastUpdatedOnTooltip'
              | translate
                : {
                    'date': fundRaiseProcess.lastUpdatedDate | amDateFormat: 'DD MMM YYYY, HH:mm a',
                  }
          }}
        </div>
      }
    </div>
  } @else {
    -
  }
  <div class="app-process-list__group">
    <div class="app-process-list__group-header">Required for Pre-Live</div>
    <div class="app-process-list__group-body">
      <div class="app-process-list__grid">
        @for (item of fundRaiseProcess.items; track item) {
          <ng-template *ngTemplateOutlet="row; context: { item: item }"></ng-template>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #row let-item="item" let-isChild="isChild">
  <div class="app-process-list__grid-row" [class.app-process-list__grid-row--child]="isChild">
    <!-- Title -->
    <div class="app-process-list__grid-cell cell--title">
      <div class="tw-flex tw-items-start tw-gap-2.5">
        <div
          class="pitchin-icon pitchin-icon-check-grey tw-flex-shrink-0"
          [class.pitchin-icon-check-green]="
            item.raiseFundApplicationProcessStatusType ===
            RaiseFundApplicationProcessStatusType.Approved
          "
        ></div>
        <div class="">
          <span class="tw-pr-2">{{ item.title }}</span>
          @if (
            item.raiseFundApplicationActionType !== RaiseFundApplicationActionType.UploadReceipt &&
            item.sampleAttachmentUrl &&
            !item.attachment
          ) {
            <span
              class="p-link-secondary p-link-underline tw-text-xs"
              (click)="viewDetails(item.sampleAttachmentUrl)"
              >{{ 'signUp.template' | translate }}
            </span>
          }
        </div>
      </div>
    </div>

    <!-- Cta -->
    <div class="app-process-list__grid-cell cell--cta">
      <ng-template *ngTemplateOutlet="action; context: { item: item }"></ng-template>
    </div>

    <!-- Status -->
    <div class="app-process-list__grid-cell cell--status">
      @if (
        !isDraftItem(item) &&
        item.raiseFundApplicationProcessStatusType !== RaiseFundApplicationProcessStatusType.None &&
        ![
          RaiseFundApplicationActionType.UploadReceipt,
          RaiseFundApplicationActionType.Attachment,
        ].includes(item.raiseFundApplicationActionType)
      ) {
        <div class="tw-flex">
          <div
            class="tw-flex tw-flex-row tw-items-center tw-leading-tight"
            [class.tw-text-secondary-light]="
              [
                RaiseFundApplicationProcessStatusType.Approved,
                RaiseFundApplicationProcessStatusType.Paid,
                RaiseFundApplicationProcessStatusType.BypassPayment,
              ].includes(item.raiseFundApplicationProcessStatusType)
            "
            [class.tw-text-warning]="
              [
                RaiseFundApplicationProcessStatusType.Pending,
                RaiseFundApplicationProcessStatusType.PendingIssuerApproval,
                RaiseFundApplicationProcessStatusType.PendingPayment,
                RaiseFundApplicationProcessStatusType.PendingFPXApproval,
                RaiseFundApplicationProcessStatusType.None,
              ].includes(item.raiseFundApplicationProcessStatusType)
            "
            [class.tw-text-primary]="
              [
                RaiseFundApplicationProcessStatusType.Rejected,
                RaiseFundApplicationProcessStatusType.RejectedByIssuer,
              ].includes(item.raiseFundApplicationProcessStatusType)
            "
          >
            <i class="fa fa-circle app-process-list__status-bar-icon tw-mr-2.5"></i>
            <div>
              {{
                'raise.' +
                  RaiseFundApplicationProcessStatusType[item.raiseFundApplicationProcessStatusType]
                  | translate
              }}
            </div>
          </div>
          <button
            type="button"
            #tooltip="matTooltip"
            (click)="tooltip.toggle()"
            class="btn-transparent d-flex"
            matTooltip="{{
              'raise.lastUpdatedOnTooltip'
                | translate: { date: item.lastUpdatedDate | amDateFormat: 'DD MMM YYYY, HH:mm a' }
            }}"
            matTooltipClass="tooltip-inner"
          >
            <div class="pitchin-icon pitchin-icon-info-grey-small p-icon-tooltip"></div>
          </button>
          @if (
            item.raiseFundApplicationProcessStatusType ===
              RaiseFundApplicationProcessStatusType.Paid && fundRaiseProcess.paymentRef
          ) {
            <div class="tw-text-body-dark">#{{ fundRaiseProcess.paymentRef }}</div>
          }
          @if (
            [
              RaiseFundApplicationProcessStatusType.Rejected,
              RaiseFundApplicationProcessStatusType.RejectedByIssuer,
            ].includes(item.raiseFundApplicationProcessStatusType)
          ) {
            @if (item.remark) {
              <div class="tw-text-body-dark">{{ 'raise.remark' | translate }} :</div>
              <div class="">{{ item.remark }}</div>
            }
          }
        </div>
      }
    </div>

    <!-- Files / Details -->
    <div class="app-process-list__grid-cell cell--files">
      @if (item.attachment?.fileName) {
        <ul class="tw-mb-0 tw-list-none tw-pl-0">
          <li>
            <div
              class="tw-flex tw-items-center tw-whitespace-nowrap"
              [title]="item.attachment?.fileName"
              (click)="viewDetails(item.attachment?.url)"
            >
              <div class="pitchin-icon pitchin-icon-document tw-mr-2.5 tw-flex-shrink-0"></div>
              <span
                class="p-link-primary p-link-underline tw-overflow-hidden tw-text-ellipsis md:tw-max-w-[80%] md:tw-flex-[0_0_80%]"
              >
                {{ item.attachment?.fileName }}
              </span>
            </div>
          </li>
        </ul>
      }

      <ng-template *ngTemplateOutlet="detail; context: { item: item }"></ng-template>
    </div>
  </div>

  <!-- For childs -->
  @if (item?.subItems) {
    @for (subItem of item.subItems; track subItem) {
      <ng-template *ngTemplateOutlet="row; context: { item: subItem, isChild: true }"></ng-template>
    }
  }
</ng-template>

<ng-template #detail let-item="item">
  @if (item.raiseFundApplicationProcessStatusType !== RaiseFundApplicationActionType.None) {
    @switch (item.raiseFundApplicationActionType) {
      @case (RaiseFundApplicationActionType.DynamicForm) {
        @if (
          [
            RaiseFundApplicationProcessModule.FundRaiseApplication,
            RaiseFundApplicationProcessModule.DueDiligence,
          ].includes(tabContent.tab)
        ) {
          <div
            class="p-link-secondary p-link-underline"
            [routerLink]="
              'detail/' +
              fundRaiseApplicationId +
              '/steps/' +
              item.id +
              '/submission/' +
              item.dynamicFormSubmissionId
            "
          >
            {{ 'common.view' | translate }}
          </div>
        }
      }
      @case (RaiseFundApplicationActionType.OfferCreation) {
        <div
          class="p-link-secondary p-link-underline"
          [routerLink]="['/raise/offer-creation', fundRaiseApplicationId]"
        >
          {{ 'common.view' | translate }}
        </div>
      }
      @case (RaiseFundApplicationActionType.CreateCampaign) {
        @if (
          tabContent.tab === RaiseFundApplicationProcessModule.CreateCampaign && !isDraftItem(item)
        ) {
          <div
            class="p-link-secondary p-link-underline"
            [routerLink]="['/raise/campaign-details', fundRaiseApplicationId, item.campaignId]"
          >
            {{ 'common.view' | translate }}
          </div>
        }
      }
      @case (RaiseFundApplicationActionType.Ekyc) {
        <div class="p-link-secondary p-link-underline" [routerLink]="['/ekyc/detail']">
          {{ 'common.view' | translate }}
        </div>
      }
      @case (RaiseFundApplicationActionType.UploadDocument) {
        <!-- Empty, show document list -->
      }
      @case (RaiseFundApplicationActionType.Attachment) {
        <!-- Empty, show document list -->
      }
      @case (RaiseFundApplicationActionType.UploadCampaignVideo) {
        <!-- <div class="link" *ngIf="item.attachment" (click)="viewDetails(item.attachment.url)">
        {{ 'common.viewVideo' | translate }}
      </div> -->
      }
      @case (RaiseFundApplicationActionType.UploadReceipt) {
        <!-- <div class="link" *ngIf="item.attachment" (click)="viewDetails(item.attachment.url)">
      {{ 'common.viewReceipt' | translate }}
    </div> -->
      }
      @case (RaiseFundApplicationActionType.FPXPayment) {
        @if (item.paymentGatewayReferenceNumber) {
          <div
            class="link"
            [routerLink]="'/raise-fund-receipt/' + item.paymentGatewayReferenceNumber"
          >
            {{ 'common.viewReceipt' | translate }}
          </div>
        }
      }
    }
  }
</ng-template>

<ng-template #action let-item="item">
  <ng-container>
    @if (item.raiseFundApplicationActionType === RaiseFundApplicationActionType.DynamicForm) {
      <button
        type="btn"
        class="btn btn-outline-primary"
        [routerLink]="
          item.raiseFundApplicationProcessStatusType ===
          RaiseFundApplicationProcessStatusType.Rejected
            ? 'form/' +
              fundRaiseApplicationId +
              '/steps/' +
              item.id +
              '/submission/' +
              item.dynamicFormSubmissionId
            : 'form/' + fundRaiseApplicationId + '/steps/' + item.id
        "
        [disabled]="
          item.raiseFundApplicationProcessStatusType ===
          RaiseFundApplicationProcessStatusType.Approved
        "
      >
        {{ 'raise.fillAndSubmit' | translate }}
      </button>
    }
    @if (
      item.raiseFundApplicationProcessStatusType === RaiseFundApplicationProcessStatusType.None ||
      item.raiseFundApplicationProcessStatusType === RaiseFundApplicationProcessStatusType.Rejected
    ) {
      @if (item.raiseFundApplicationActionType === RaiseFundApplicationActionType.EKYC) {
        <div class="d-flex flex-row align-items-center pending">
          <i class="fa fa-circle mr-3"></i> {{ 'raise.pendingAdminVerification' | translate }}
        </div>
      }
    }
    <!-- Todo: check this in create campaign -->
    @if (
      item.campaignId &&
      item.raiseFundApplicationActionType === RaiseFundApplicationActionType.CreateCampaign
    ) {
      <a
        class="btn btn-outline-primary"
        [routerLink]="['/raise/edit-campaign', fundRaiseApplicationId, item.campaignId]"
      >
        --{{ 'raise.fillAndSubmit' | translate }}
      </a>
    }
  </ng-container>
  @if (
    item.raiseFundApplicationProcessStatusType === RaiseFundApplicationProcessStatusType.None &&
    item.raiseFundApplicationActionType == RaiseFundApplicationActionType.OfferCreation
  ) {
    <div class="d-flex flex-row align-items-center pending">
      <i class="fa fa-circle mr-3"></i>
      <div>{{ 'raise.PendingOfferCreation' | translate }}</div>
    </div>
  }
  @if (
    item.raiseFundApplicationActionType === RaiseFundApplicationActionType.FPXPayment &&
    [
      RaiseFundApplicationProcessStatusType.None,
      RaiseFundApplicationProcessStatusType.Rejected,
    ].includes(item.raiseFundApplicationProcessStatusType)
  ) {
    <div class="d-flex align-items-center">
      <button type="btn" class="btn btn-outline-primary" (click)="makePayment()">
        {{ 'raise.makePayment' | translate }}
      </button>
    </div>
  }
  @if (
    [
      RaiseFundApplicationActionType.UploadDocument,
      RaiseFundApplicationActionType.UploadVideo,
      RaiseFundApplicationActionType.UploadCampaignVideo,
    ].includes(item.raiseFundApplicationActionType)
  ) {
    @if (
      item.raiseFundApplicationProcessStatusType === RaiseFundApplicationProcessStatusType.None ||
      item.raiseFundApplicationProcessStatusType === RaiseFundApplicationProcessStatusType.Rejected
    ) {
      <div class="input-field">
        @if (!item.attachment || !item.attachmentUrl) {
          <div
            class="document-upload cursor-pointer tw-text-center"
            agmoUploader
            [accept]="getAcceptType(item.raiseFundApplicationActionType)"
            (selectFiles)="selectFile($event, item)"
            [class.disabled]="
              item.raiseFundApplicationProcessStatusType ===
              RaiseFundApplicationProcessStatusType.Approved
            "
          >
            <div class="document-text">
              {{ 'common.upload' | translate }}
            </div>
          </div>
        }
        @if (item.attachment && item.attachmentUrl) {
          <div class="document-upload uploaded">
            <div class="document-text">{{ item.attachment.name }}</div>
          </div>
        }
      </div>
    }
  }
  @if (item.raiseFundApplicationActionType === RaiseFundApplicationActionType.UploadMultipleFile) {
    <div
      class="document-upload cursor-pointer tw-text-center"
      (click)="uploadAdditionalDocument(item)"
    >
      <div class="document-text">
        {{ 'common.upload' | translate }}
      </div>
    </div>
  }
  <!-- Todo: check this functionality -->
  <!-- <ng-container
  *ngIf="item.raiseFundApplicationActionType === RaiseFundApplicationActionType.Attachment && item.raiseFundApplicationProcessStatusType !== RaiseFundApplicationProcessStatusType.Approved">
  <button class="btn btn-outline-primary" (click)="removeAttachmentByAttachmentId(item.id, parent?.id)">
    {{ 'company.deleteDocument' | translate }}
  </button>
</ng-container> -->
</ng-template>
